// 第三方 发起问诊
import http from '../request';

const joinFreeConsultation = (params) => http({
  app: 'banyanSi',
  method: 'post',
  // url: '/maserati/consultation/drugRequre/joinFreeConsultation',
  url: '/maserati/consultation/joinFreeConsultation',
  data: params,
});

const getDiagnoseByUniCode = (params) => http({
  app: 'banyanSi',
  method: 'post',
  // url: '/maserati/consultation/drugRequre/getDrugFunction',
  url: '/maserati/consultation/getDiagnoseByUniCode',
  data: params,
});

const getMedDiagnoseByUniCode = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/getMedDiagnoseByUniCode',
  data: params,
});

const getDrugRequire = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/drugRequire/selectDetail',
  data: params,
  noErrorMsg: true,
});

const updateMedicineHelpIdStatus = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/mall-assistant/visitPres/updateStatus',
  data: params,
});

const getConsultationDetail = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/getConsultationInfo',
  data: params,
});
// 新冠编号和版本对应表
const covidMapList = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/covidDiagnoses',
  data: params,
});
// // 获取配置必填项
// const getControlWrite = (params) => http({
//   app: 'banyanSi',
//   method: 'post',
//   url: '/maserati/hospitalConfigDict/getByCategoryCode',
//   data: params,
// });

// 获取接诊医院配置
const getSetHospital = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/mall-assistant/shop/getShopInquiryHospital',
  data: params,
});

// 获取药品诊断列表
const queryDrugDiagnose = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/drugRequire/queryDrugDiagnose',
  data: params,
});

// 医保诊断列表
const getRegionDiagnosePage = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/pageRegionDiagnose',
  data: params,
});

// 诊断列表
const getDiagnoseListApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/pagePaasDiagnose',
  data: params,
});
// 校验诊断性别
const checkDiagnoseSexApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/mall-assistant/irrationalDrug/checkDiagnoseSex',
  data: params,
});

// 获取病情页配置
const getPatientInfoSetting = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/diseasePage/getByHospitalType',
  data: params,
});

// 合规智控平台 - 规则校验
const checkRuleApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/ruleEngine/rule/checkRule',
  data: params,
});

// 合规智控平台 - 是否接受校验
const acceptOrNotRuleApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/ruleEngine/rule/acceptRuler',
  data: params,
});

export {
  joinFreeConsultation,
  getDiagnoseByUniCode,
  getMedDiagnoseByUniCode,
  getDrugRequire,
  updateMedicineHelpIdStatus,
  getConsultationDetail,
  covidMapList,
  // getControlWrite,
  getSetHospital,
  getRegionDiagnosePage,
  getDiagnoseListApi,
  checkDiagnoseSexApi,
  getPatientInfoSetting,
  checkRuleApi,
  acceptOrNotRuleApi,
  queryDrugDiagnose
};
